import client from './client'
import type { Category } from '../types'

export async function listCategories(): Promise<Category[]> {
  const res = await client.get('/v1/categories')
  return res.data
}
